import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, IconButton, TextField, Button, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CommentBox from '../Shared/CommentBox/index.tsx';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import { LeadFormActions } from '../../Services/_actions/index.js';
import { dateFormate } from '../../utils/helper.jsx';

interface ViewCommentModalProps {
  open: boolean;
  onClose: () => void;
  selectedRow?: any;
  onSaveComment?: (comment: string, id: number) => void;
}

const ViewCommentModal: React.FC<ViewCommentModalProps> = ({
  open,
  onClose,
  selectedRow,
  onSaveComment,
}) => {
  const actions = LeadFormActions();
  const [commentList, setCommentList] = useState<any>([]);
  const { showSnackBar } = useSnackBar();

  const addComment = async (commentText: string) => {
    try {
      if (commentText) {
        const response: any = await actions.postCommentById(
          { comment: commentText, id: selectedRow?.id },
          selectedRow?.id
        );
        if (response && response.status === 200) {
          setCommentList([...commentList, { comment: commentText, created_at: new Date() }]);
          if (onSaveComment && selectedRow?.id) {
            onSaveComment(commentText, selectedRow.id);
          }
          showSnackBar('Comment added successfully', 'success');
        } else {
          showSnackBar('Failed to add comment', 'error');
        }
      }
    } catch (error) {
      showSnackBar(error?.toString() || 'Error', 'error');
    }
  };

  useEffect(() => {
    try {
      if (selectedRow?.internal_comments && selectedRow?.internal_comments?.length > 0 ) setCommentList([...selectedRow?.internal_comments]);
    } catch (error) {
      console.error('Error setting comment list:', error);
    }
  }, [selectedRow]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        className="comment-box-wrapper"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
          width: 600,
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" fontWeight="bold">
            View Comments
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <CommentBox
          commentList={commentList || []}
          onSubmitComment={(commentText) => addComment(commentText)}
        />
      </Box>
    </Modal>
  );
};

export default ViewCommentModal;
